import { Link } from '@tanstack/react-router'
import { CONTACT_EMAIL, CONTACT_MAILTO_URL, SOCIAL } from '@/lib/constants'

export function SiteFooter() {
  return (
    <footer className="marketing-footer bg-body-secondary mt-auto py-5">
      <div className="container">
        <div className="row g-4 align-items-start">
          <div className="col-md-8">
            <p className="mb-1 fw-semibold">Halo Compliance</p>
            <p className="mb-3 small">
              The speed and protection you deserve from mortgage marketing compliance.
            </p>
            <p className="small mb-1">
              <span className="text-body-secondary">Contact</span>
            </p>
            <a className="text-decoration-none" href={CONTACT_MAILTO_URL}>
              {CONTACT_EMAIL}
            </a>
          </div>
          <div className="col-md-4 text-md-end">
            <div className="d-flex gap-3 justify-content-md-end mb-3">
              <a
                href={SOCIAL.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-body-secondary hover-warning"
                aria-label="Facebook"
              >
                <i className="bi bi-facebook fs-4" />
              </a>
              <a
                href={SOCIAL.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="text-body-secondary hover-warning"
                aria-label="LinkedIn"
              >
                <i className="bi bi-linkedin fs-4" />
              </a>
            </div>
            <ul className="list-unstyled small mb-0">
              <li className="mb-2">
                <Link to="/terms-of-service" className="link-underline-opacity-25 link-underline-opacity-100-hover">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="link-underline-opacity-25 link-underline-opacity-100-hover">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}
